@switch (template) {
  @case ("string") {
    <ng-container *ngTemplateOutlet="stringTemplate"></ng-container>
  }
  @case ("date") {
    <ng-container *ngTemplateOutlet="dateTemplate"></ng-container>
  }
  @case ("dateRange") {
    <ng-container *ngTemplateOutlet="dateRangeTemplate"></ng-container>
  }
  @case ("decimal") {
    <ng-container *ngTemplateOutlet="decimalTemplate"></ng-container>
  }
  @case ("dropdown") {
    <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
  }
  @case ("selectButton") {
    <ng-container *ngTemplateOutlet="selectButtonTemplate"></ng-container>
  }
  @case ("checkbox") {
    <ng-container *ngTemplateOutlet="checkboxTemplate"></ng-container>
  }
  @case ("toggle") {
    <ng-container *ngTemplateOutlet="toggleTemplate"></ng-container>
  }
  @case ("unitOfMeasure") {
    <ng-container *ngTemplateOutlet="unitOfMeasureTemplate"></ng-container>
  }
  @case ("custom") {
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
  }
}

<ng-template #labelTemplate>
  <div *transloco="let t">
    <label for="{{ fieldName }}"
      >{{
        t(fieldName | case: "snake" | replace: "amount_" : "amount.")
          | case: "upperFirst"
      }}:</label
    >
  </div>
</ng-template>

<ng-template #customTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #stringTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <input
      type="text"
      pInputText
      autocomplete="nope"
      [(ngModel)]="model[fieldName]"
      [disabled]="disabled"
    />
  </div>
</ng-template>

<ng-template #unitOfMeasureTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div *transloco="let t">
    <p-select
      #unitOfMeasure
      [(ngModel)]="model[fieldName]"
      [options]="selectOptions"
      [filter]="false"
      optionLabel="name"
      optionValue="name"
      appendTo="body"
      (onChange)="setUnitOfMeasureOwn($event)"
      dropdownIcon="icon-chevronDown-outline -top-1px relative"
    ></p-select>

    <ng-container>
      @if (model.unitOfMeasure === "OWN") {
        <input
          #unitOfMeasureOwn
          type="text"
          [placeholder]="t('unitofmeasure_own') + '...'"
          pInputText
          autocomplete="nope"
          class="ml-2 min-w-64"
          [(ngModel)]="model.unitOfMeasureOwn"
          [autofocus]="true"
          [disabled]="model.unitOfMeasure !== 'OWN'"
        />
      }
    </ng-container>
  </div>
</ng-template>

<ng-template #dropdownTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <p-select
      styleClass=""
      [(ngModel)]="model[fieldName]"
      [disabled]="disabled"
      [options]="selectOptions"
      [filter]="false"
      optionLabel="name"
      optionValue="key"
      appendTo="body"
      dropdownIcon="icon-chevronDown-outline -top-1px relative"
    ></p-select>
  </div>
</ng-template>

<ng-template #selectButtonTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <p-selectButton
      [(ngModel)]="model[fieldName]"
      [disabled]="disabled"
      [options]="selectOptions"
      optionLabel="name"
      optionValue="key"
      appendTo="body"
    ></p-selectButton>
  </div>
</ng-template>

<ng-template #toggleTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <p-toggleswitch
      [(ngModel)]="model[fieldName]"
      [disabled]="disabled"
      (onChange)="toggleOnChange($event)"
      class="inline-block relative top-2 mb-2 {{ classes }}"
    ></p-toggleswitch>
  </div>
</ng-template>

<ng-template #checkboxTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div>
    <p-checkbox [binary]="true" [(ngModel)]="model[fieldName]"></p-checkbox>
  </div>
</ng-template>

<ng-template #decimalTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div *transloco="let t">
    <p-inputNumber
      type="number"
      autocomplete="nope"
      [(ngModel)]="model[fieldName]"
      [pKeyFilter]="'pnum'"
      [minFractionDigits]="2"
      [maxFractionDigits]="6"
      [showButtons]="true"
      [locale]="t('lang')"
      [disabled]="disabled"
    >
    </p-inputNumber>
  </div>
</ng-template>

<ng-template #dateTemplate>
  <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  <div *transloco="let t">
    <p-datepicker
      appendTo="body"
      [disabled]="disabled"
      icon="icon-calendar-outline"
      [showIcon]="true"
      dateFormat="yy.mm.dd."
      [(ngModel)]="model[fieldName]"
      [dataType]="calendarDataType"
    >
    </p-datepicker>
  </div>
</ng-template>

<ng-template #dateRangeTemplate>
  @if (!hideLabel) {
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  }
  <div *transloco="let t">
    @if(dateOptions.length > 1){
 <p-datepicker
      pRipple
      #dateRangeCalendar
      [(ngModel)]="model[fieldName]"
      appendTo="body"
      dateFormat="yy.mm.dd."
      selectionMode="range"
      inputStyleClass="w-64"
      icon="icon-calendar-outline"
      rangeSeparator="–"
      [disabled]="disabled"
      [dataType]="calendarDataType"
      [showButtonBar]="true"
      [numberOfMonths]="2"
      [showOtherMonths]="false"
      [readonlyInput]="true"
      [showIcon]="true"
      [placeholder]="t('please_select')"
      (onClose)="setDateRangeValues($event, dateRangeCalendar)"
    >  
      <ng-template #date let-date>
          <span
            [class.disabled-date]="!isCalendarDateAllowed(date)">
            {{ date.day }}
        </span>
      </ng-template>
    </p-datepicker>
    }
    @else {
      <p-datepicker
      pRipple
      #dateRangeCalendar
      [(ngModel)]="model[fieldName]"
      appendTo="body"
      dateFormat="yy.mm.dd."
      selectionMode="range"
      inputStyleClass="w-64"
      icon="icon-calendar-outline"
      rangeSeparator="–"
      [disabled]="disabled"
      [dataType]="calendarDataType"
      [maxDate]="dateOptions[0]?.end"
      [minDate]="dateOptions[0]?.start"
      [showButtonBar]="true"
      [numberOfMonths]="2"
      [showOtherMonths]="false"
      [readonlyInput]="true"
      [showIcon]="true"
      [placeholder]="t('please_select')"
      (onClose)="setDateRangeValues($event, dateRangeCalendar)"/> 
    }
   
  </div>
</ng-template>
